import PropTypes from "prop-types";
import React from "react";
import { Box } from "@mui/material";

export default function LibraryPolicies(props) {
  const policyPartnerUrl = localStorage.getItem("policyPartnerUrl");

  return (
    <Box display="flex" flexDirection="column">
      <iframe
        src={policyPartnerUrl}
        width="100%"
        height="800"
        title="policyPartnerIFrame"
      />
    </Box>
  );
}

LibraryPolicies.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
  match: PropTypes.any
};
